@for (row of rows(); track row.key) {
  <div class="alert mb-2" [ngClass]="alertClass(row.phase)" role="alert">
    <div class="d-flex justify-content-between align-items-start gap-2">
      <span class="fw-medium text-break">{{ row.label }}</span>
      @if (row.phase === 'transferring' && row.progressPercent !== null) {
        <span class="text-nowrap small">{{ row.progressPercent }}%</span>
      }
    </div>
    <div class="small mt-1 d-flex align-items-start gap-2">
      <span class="status-icon flex-shrink-0">
        @switch (row.phase) {
          @case ('queued') {
            <i class="bi bi-clock"></i>
          }
          @case ('preparing') {
            <i class="bi bi-key"></i>
          }
          @case ('transferring') {
            <i class="bi bi-upload"></i>
          }
          @case ('finalizing') {
            <i class="bi bi-check2-circle"></i>
          }
          @case ('parsing') {
            <i class="bi bi-gear"></i>
          }
          @case ('completed') {
            <i class="bi bi-check-square"></i>
          }
          @case ('failed') {
            <i class="bi bi-exclamation-square"></i>
          }
        }
      </span>
      <span>{{ row.message }}</span>
    </div>
    @if (showProgress(row)) {
      <div class="progress mt-2" style="height: 6px">
        <div
          class="progress-bar"
          role="progressbar"
          [style.width.%]="row.progressPercent"
          [attr.aria-valuenow]="row.progressPercent"
          aria-valuemin="0"
          aria-valuemax="100"></div>
      </div>
    }
    @if (row.detail) {
      <div class="small text-danger-emphasis mt-2">{{ row.detail }}</div>
    }
  </div>
}
